import {
  useLazyGetCalendarVisitsDataQuery,
  useLazyGetDataReviewCRFsQuery,
  useLazyGetDataReviewDataQuery,
  useLazyGetDataReviewVisitsQuery
} from 'src/services/DataReview';

export const useDataReview = () => {
  const [
    getDataReviewData,
    { data: dataReviewData, error: dataReviewDataError, isError: dataReviewIsError, isLoading: dataReviewDataIsLoading }
  ] = useLazyGetDataReviewDataQuery();

  const [
    getSubjectsCalendarVisitsData,
    {
      data: subjectsCalendarVisitsData,
      error: subjectsCalendarVisitsError,
      isSuccess: subjectsCalendarVisitsIsSuccess,
      isError: subjectsCalendarVisitsIsError,
      isLoading: subjectsCalendarVisitsIsLoading
    }
  ] = useLazyGetCalendarVisitsDataQuery();

  const [
    getDataReviewVisits,
    {
      data: dataReviewVisits,
      error: dataReviewVisitsError,
      isError: dataReviewVisitsIsError,
      isLoading: dataReviewVisitsIsLoading
    }
  ] = useLazyGetDataReviewVisitsQuery();
  const [
    getDataReviewCRFs,
    {
      data: dataReviewCRFs,
      error: dataReviewCRFsError,
      isError: dataReviewCRFsIsError,
      isLoading: dataReviewCRFsIsLoading
    }
  ] = useLazyGetDataReviewCRFsQuery();
  return {
    dataReviewData,
    dataReviewDataError,
    dataReviewIsError,
    dataReviewDataIsLoading,
    getDataReviewData,
    dataReviewVisits,
    dataReviewVisitsError,
    dataReviewVisitsIsError,
    dataReviewVisitsIsLoading,
    getDataReviewVisits,
    dataReviewCRFs,
    dataReviewCRFsError,
    dataReviewCRFsIsError,
    dataReviewCRFsIsLoading,
    getDataReviewCRFs,
    getSubjectsCalendarVisitsData,
    subjectsCalendarVisitsData,
    subjectsCalendarVisitsError,
    subjectsCalendarVisitsIsSuccess,
    subjectsCalendarVisitsIsError,
    subjectsCalendarVisitsIsLoading
  };
};
